import React from 'react';
import ReactDOM from 'react-dom/client';
import reducer from './store/reducers'
import App from './App';
import {createStore} from 'redux'
import { Provider } from 'react-redux';



const store = createStore (reducer) 



const root = ReactDOM.createRoot(document.getElementById('root'));
const data  = document.getElementById('root')
const sid = data.getAttribute('sid')
root.render(
    <Provider store={store}>
    <App  sid={sid}/>
    </Provider>
);


